<template>
  <div class="mb-3">
    <v-card dark class="elevation-5" style="width: 250px">
      <v-list class="py-0" style="background-color: #000">
        <v-list-tile>
          <v-list-tile-title
            style="text-align: center; font-size: 20px; color: white"
            >HOTEL SERVICES</v-list-tile-title
          >
        </v-list-tile>
      </v-list>
      <v-list class="py-0" style="overflow: hidden">
        <div v-for="item in filterNogroupItem" :key="item.title">
          <v-list-tile :to="item.url">
            <v-list-tile-action>
              <v-icon>{{ item.action }}</v-icon>
            </v-list-tile-action>
            <v-list-tile-content>
              <v-list-tile-title>{{ item.title }}</v-list-tile-title>
            </v-list-tile-content>
          </v-list-tile>
        </div>
        <v-list-group
          v-for="item in filteredSidebar"
          v-model="item.active"
          :key="item.title"
          :prepend-icon="item.action"
          no-action
        >
          <v-list-tile slot="activator">
            <v-list-tile-content>
              <v-list-tile-title>{{ item.title }}</v-list-tile-title>
            </v-list-tile-content>
          </v-list-tile>
        </v-list-group>
      </v-list>
    </v-card>
  </div>
</template>

<script>
import { mapState } from "vuex";
export default {
  data() {
    return {
      itemNoGroup: [
        {
          active: true,
          action: "domain",
          permission_name: "hotel_manage",
          title: "Hotel List",
          url: "/weserve_admin_login/-/hotel-services/hotel-list",
        },
      ],
      items: [],
    };
  },
  computed: {
    ...mapState({
      permission: (state) => state.permission,
    }),
    filteredSidebar() {
      return this.items.filter((val) => {
        for (let val2 in this.permission.main_menu.hotel_service) {
          if (val2 == val.permission_name) return val;
        }
      });
    },
    filterNogroupItem() {
      return this.itemNoGroup.filter((val) => {
        for (let val2 in this.permission.main_menu.hotel_service) {
          if (val2 == val.permission_name) return val;
        }
      });
    },
  },
};
</script>
